import type { CreateOrdersCardMountData } from '../../../../global_state/src/cardLayersReducer';
import type { DemandFilterInput } from '@buying/library';

// This is used to open a card without fetching order groups and its orders. It's used for easy development by opening a card with real data.
const realCreateOrderCardMountData: CreateOrdersCardMountData = {
    demandGroup: {
        collection: {
            collectionNumber: 56596,
            collectionName: '2027 MAIN #2',
            collectionTerm: '27 MAIN #2',
            isDeleted: false,
        },
        issuer: {
            issuerNumber: 104,
            issuerName: 'BESTSELLER A/S',
            issuerShortName: 'DENMARK',
            isDeleted: false,
        },
        supplier: {
            companyName: 'A.K.M. Knit Wear Limited',
            companyNumber: '531339',
            isDeleted: false,
        },
        styleCount: 52,
        brandNumber: '04',
        demandGroupNumber: 'c489aa4f-e25e-4a51-a95c-537c5413bd24',
        inProgressCount: 0,
        totalQuantityPieces: 16991,
    },
    brand: {
        brandName: 'Jack & Jones',
        brandNumber: '04',
    },
    filters: {
        buyerNumber: [],
        productLineNumber: [],
        masterStyleCategoryNumber: [],
        purchaseDivisionNumber: [],
        deliveryPeriodNumber: [],
        styleNumbers: [],
    } as DemandFilterInput,
};

export { realCreateOrderCardMountData };
